import { Module } from 'vuex';
import { InterviewRequestState } from './types';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const interviewRequest: Module<InterviewRequestState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default interviewRequest;
